import React, { useState } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { authPut } from "../../../util/request/authPut";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CompleteParty = (props) => {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [price, setPrice] = useState(
    props.eventData.package.non_refundable_deposite
  );

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    const result = await authPut({
      subLink: "booking",
      id: props.eventData._id,
      data: {
        booking_status: "completed",
      },
    });
    if (result.status === "success") {
      props.reFreshData();

      setOpen(false);
    }

    handleClose();
  };

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{ maxWidth: "100px" }}
        color="success"
      >
        Complete
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" gutterBottom>
            Party completed: {props.eventData.bookingDetail.celebrant}
          </Typography>

          <Stack direction="row" justifyContent="flex-end">
            <Button
              variant="outlined"
              fullWidth
              onClick={handleClose}
              sx={{ maxWidth: "100px", mr: "50px" }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              sx={{ maxWidth: "100px" }}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default CompleteParty;
